import Home_Header from '../../images/home_header.png'
import React, { useContext } from 'react';
import Filter from '../../components/Filter/Filter';
import TableComponent from '../../components/Table/Table';
import CardComponent from '../../components/Card/CardComponent';
import { GlobalState } from '../../GlobalState';


function Home() {

    const state = useContext(GlobalState)
    const [showMethod] = state.showMethod

    return (
        <div className="full-height">
            <div className="d-flex justify-content-center custom_gradient">
                <img className="mt-2 mobile_home_header" src={Home_Header} />
            </div>

            {/* To select, search, sort data */}
            <div className="container">
                <Filter />
            </div>

            {/* showing data as a table default */}
            { showMethod === "table" ? (
                <div className="container">
                    <TableComponent />
                </div>
            ) : (
                <div className="container">
                    <CardComponent />
                </div>
            )}
        </div>
    )
}

export default Home
